module.exports = __webpack_public_path__ + "static/media/inf_13og14.8dca7012.mp3";